import { useEffect, useState } from "react";
import type { ExperimentConfig, OptimizelyEvent } from "stores/OptimizelyStore";
import { useOptimizelyStore } from "stores/OptimizelyStore";
import config from "config/config";
import { appendExternalScript } from "utils/appendExternalScript/appendExternalScript";
import { useLanguage } from "contexts/LocalizationContext";
import useExtendedRouter from "hooks/useExtendedRouter";
import { getOptimizelyVariations, isSupportedUrl, pushConversionEvent } from "./utils";

export const useOptimizely = (experimentConfig: ExperimentConfig) => {
  const language = useLanguage();
  const router = useExtendedRouter();
  const { setOptimizelyLoading, setOptimizelyLoaded, setOptimizelyError, isLoading, isLoaded, hasError } =
    useOptimizelyStore();
  const [variation, setVariation] = useState<number>(null);
  const isSupportedPage = isSupportedUrl(experimentConfig, language, router);

  const setOptimizelyVariation = (event: OptimizelyEvent, experiment: ExperimentConfig) => {
    if (hasError) {
      return;
    }
    const { variationId } = event.data.decision;
    const variation = experiment.variations[variationId] || null;
    setVariation(variation);
  };

  useEffect(() => {
    if (!isSupportedPage) {
      return;
    }

    appendExternalScript(config.optimizelyScriptUrl, setOptimizelyLoading, setOptimizelyLoaded, setOptimizelyError);
    getOptimizelyVariations((event) => setOptimizelyVariation(event, experimentConfig));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupportedPage]);

  return {
    variation: isSupportedPage ? variation : null,
    pushConversionEvent: pushConversionEvent(experimentConfig),
    isLoading,
    isLoaded,
  };
};
